import { normalizeSpeech, parseVoiceCommand } from './commands.js';

// A wake prefix opens a short command window. Ordinary conversation stays idle.
export class VoiceCommandSession {
  constructor(onCommand, onPhase, getPrefix, timers = { set: (fn, ms) => setTimeout(fn, ms), clear: id => clearTimeout(id) }) {
    Object.assign(this, { onCommand, onPhase, getPrefix, timers });
    this.phase = 'idle'; this.carryPrefix = false;
  }
  setPhase(phase) {
    if (phase === this.phase) return;
    this.phase = phase; this.onPhase(phase);
  }
  cancel() {
    this.timers.clear(this.timer); this.timer = null; this.carryPrefix = false;
    this.pauseDelivered = false;
    this.setPhase('idle');
  }
  reject() {
    this.timers.clear(this.timer); this.carryPrefix = false;
    this.setPhase('unrecognized');
    this.timer = this.timers.set(() => this.cancel(), 1200);
  }
  finishUnmatched() { this.pauseDelivered = false; if (this.phase === 'listening') this.reject(); }
  consume(transcript, isFinal, at) {
    const prefix = normalizeSpeech(this.getPrefix());
    if (this.prefix !== prefix) { this.cancel(); this.prefix = prefix; }
    // An early pause already handled this recognition result. Its later interim
    // revisions and final transcript must not repeat the action or its feedback.
    if (this.pauseDelivered) { if (isFinal) this.pauseDelivered = false; return; }
    const text = normalizeSpeech(transcript);
    const prefixed = !!prefix && (text === prefix || text.startsWith(`${prefix} `));
    if (!prefixed && !this.carryPrefix) {
      // An interim hypothesis may be corrected before becoming final.
      if (this.phase === 'listening') this.cancel();
      return;
    }
    this.timers.clear(this.timer); this.setPhase('listening');
    this.timer = this.timers.set(() => this.reject(), 4000);
    if (text === prefix && isFinal) {
      // Native speech engines may finalize the prefix before the following words.
      this.carryPrefix = true; return;
    }
    const command = parseVoiceCommand(prefixed ? text : `${prefix} ${text}`, prefix);
    // Tutorial audio can delay finalization. A complete, prefixed pause/stop is
    // useful immediately; changing playback and bookmarks waits for final text.
    if (!isFinal && command?.type !== 'pause') return;
    if (!command) { this.reject(); return; }
    this.cancel();
    this.pauseDelivered = !isFinal;
    this.onCommand({ ...command, source: 'voice', at });
  }
}
